import { Container, Center, Text, Box } from "@chakra-ui/react"

import useHolidays from "hooks/useHolidays"
import { useUI } from "providers/UIProvider"

import { IAddEditHolidayModalTypes } from "./AddEditHolidayModalTypes"

import Modal from "components/UI/organisms/Modal"
import HolidayForm from "./HolidayForm"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { ILaundryHoliday } from "types/laundry"

const AddEditHolidayModal: React.FC<IAddEditHolidayModalTypes> = () => {
  const { modals, toggleModal, T } = useUI()

  const laundryHolidayData: ILaundryHoliday = modals.addEditHolidayModal.data
  
  const {
    form: { values, errors, setValues, handleSubmit, resetForm }, handleDateChange, handleTimeChange
  } = useHolidays(laundryHolidayData || null)

  const handleClose = () => {
    toggleModal("addEditHolidayModal", false)
    resetForm()
  }

  return (
    <Modal
      isOpen={modals.addEditHolidayModal.isOpened}
      onClose={handleClose}
      title={T("general.holiday")}
      styles={{
        headerPadding: "15px 15px 15px 25px",
        bodyPadding: "25px 13px",
      }}
    >
      <Container padding="0 10px">
        <Center>
          <Text fontSize="xl">{T("general.holiday.choose_dates")}</Text>
        </Center>
        <Box mt="40px">
          <HolidayForm
            values={values}
            errors={errors}
            handleTimeChange={handleTimeChange}
            handleDateChange={handleDateChange}
          />
        </Box>
        <Center mt="36px">
          <Button
            text={T("actions.confirm")}
            onClick={handleSubmit}
            variant="success"
            styles={{ width: "280px", height: "80px", fontSize: "xxl" }}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "34px", height: "34px" }}
              />
            }
          />
        </Center>
      </Container>
    </Modal>
  )
}

export default AddEditHolidayModal
